module.exports = __webpack_public_path__ + "static/img/loacker.bede454.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/loacker.png
// module id = 496
// module chunks = 1